module.exports = __webpack_public_path__ + "img/enCart.80b006dc.png";